import { Component, Input, OnInit } from "@angular/core";
import { IStepAssignee } from "src/app/interfaces";
import { LogClass } from "../../../../logger";

@Component({
    selector: "circ-step-current-forwarded",
    templateUrl: "./current-step-forwarded.component.html",
    styleUrls: ["./current-step-forwarded.component.scss"],
    standalone: false
})
@LogClass({ source: "CurrentStepForwardedComponent" })
export class CurrentStepForwardedComponent implements OnInit {
  @Input() public currentAssignee: IStepAssignee;
  @Input() public assignees: IStepAssignee[];

  public forwards: IStepAssignee[];

  public ngOnInit(): void {
    this.forwards = this.assignees
      .filter(
        (a) =>
          a.forwardData &&
          a.forwardData.forwardedToId == this.currentAssignee.id
      )
      .reverse();
  }

  public getLogin(stepAssignee: IStepAssignee): string {
    return stepAssignee.user.login;
  }
}
